// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"fe795995","381":"9045e1fa","899":"c442e788","958":"a2011f0f"}[chunkId] + ".chunk.css";
};